import {
  AudienceExtractionsService,
  type AudienceExtractionAssetDto,
  type AudienceExtractionResponseDto,
} from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';

/**
 * Asks IQ to read uploaded documents and say which audiences they describe.
 *
 * Answers with the run rather than the segments: reading a deck takes longer than a request
 * should wait, so the caller watches the run from here.
 */
export const startAudienceExtraction = async (
  assets: AudienceExtractionAssetDto[],
): Promise<AudienceExtractionResponseDto> => {
  const response = await AudienceExtractionsService.create({
    client: inferenceHttp,
    body: { assets },
    throwOnError: true,
  });

  return response.data;
};

export const getAudienceExtraction = async (id: string): Promise<AudienceExtractionResponseDto> => {
  const response = await AudienceExtractionsService.get({
    client: inferenceHttp,
    path: { id },
    throwOnError: true,
  });

  return response.data;
};

/** Reads the same documents again, for a run that failed or died mid-flight. */
export const retryAudienceExtraction = async (
  id: string,
): Promise<AudienceExtractionResponseDto> => {
  const response = await AudienceExtractionsService.retry({
    client: inferenceHttp,
    path: { id },
    throwOnError: true,
  });

  return response.data;
};
